import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ProgramariBlocareService } from '../programari-blocare.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { helper } from 'src/environments/helper';
import { ProgramareSloturiBlocare } from '../programari-blocare.interface';
import { GhiseuModuleService } from '../../ghiseu-module/ghiseu-module.service';
import { LocatiiService } from '../../locatii/locatii.service';
import { notDefaultValidator } from 'src/app/shared/validators/not-default';
import { ServiciiService } from '../../servicii/servicii.service';

@Component({
    selector: 'app-add-programari-blocare',
    templateUrl: './add-programari-blocare.component.html',
    styleUrls: ['./add-programari-blocare.component.scss']
})
export class AddProgramariBlocareComponent implements OnInit {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    module!: any[];
    locatii!: any[];
    servicii!: any[];

    form: FormGroup = new FormGroup({
        id_modul: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        id_locatie: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        id_serviciu: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        date_from: new FormControl('', [Validators.required]),
        time_from: new FormControl('', [Validators.required]),
        date_end: new FormControl('', [Validators.required]),
        time_end: new FormControl('', [Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddProgramariBlocareComponent>,
        private programariSloturiBlocareService: ProgramariBlocareService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private ghiseuModuleService: GhiseuModuleService,
        private locatiiService: LocatiiService,
        private serviciiService: ServiciiService
    ) {
        this.processToken();
    }

    ngOnInit(): void {
        this.loadModule();
        this.loadLocatii();
        this.loadServicii();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.programariSloturiBlocareService.setToken(token);
        });
    }

    loadModule() {
        this.isLoading = true;
        this.ghiseuModuleService.getModule().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.module = res;
            },
            error: (err) => {
                console.error('Error in get ghiseu module: ', err);
            }
        })
    }

    loadLocatii() {
        this.isLoading = true;
        this.locatiiService.getLocatii().pipe(
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.locatii = res;
            },
            error: (err) => {
                console.error('Error in get locatii: ', err);
            }
        })
    }

    loadServicii() {
        this.isLoading = true;
        this.serviciiService.getServicii().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.servicii = res;
            },
            error: (err) => {
                console.error('Error in get servicii: ', err);
            }
        })
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    submitForm() {
        this.isLoading = true;

        const { id_modul, id_locatie, id_serviciu, date_from, date_end, time_from, time_end } = this.form.value as any;

        const newProgramareSloturiBlocare: ProgramareSloturiBlocare = {
            id_modul,
            id_locatie,
            id_serviciu,
            date_from: date_from ? this.formatDate(date_from) : '',
            date_end: date_end ? this.formatDate(date_end) : '',
            time_from,
            time_end,
        };

        this.programariSloturiBlocareService
            .addProgramareSloturiBlocare(newProgramareSloturiBlocare)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
